import styled from "styled-components";

export const SectionSupportedInitiativesContainer = styled.section(
  ({ theme }) => ({
    backgroundColor: theme.color.neutral["07"],
  })
);

export const SectionSupportedInitiativesContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    gap: "60px",
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const SectionSupportedInitiativesTitle = styled.h2(({ theme }) => ({
  fontSize: "32px",
  fontWeight: "700",
  lineHeight: "150%",
  color: theme.color.brandPrimary.light,
  margin: 0,

  [theme.breakpoint.lg()]: {
    fontSize: "40px",
  },
}));

export const SectionSupportedInitiativesFooter = styled.div(({ theme }) => ({
  display: "flex",
  fontWeight: "500",
  color: theme.color.neutral["02"],
  lineHeight: "160%",
  paddingLeft: "20px",
  borderLeft: `1px solid #40BCFF`,

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
    paddingTop: "20px",
    paddingLeft: "51%",
    border: "none",
  },
}));

export const SectionSupportedInitiativesCount = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",

  gap: "32px",
  marginTop: "40px",
  width: "100%",

  fontSize: "16px",
  fontWeight: "800",
  lineHeight: "150%",
  textTransform: "uppercase",
  letterSpacing: "2px",
  color: theme.color.brandPrimary.light,

  [theme.breakpoint.lg()]: {
    flexDirection: "row",
    fontSize: "20px",
  },

  span: {
    fontSize: "40px",
    fontWeight: "700",
    color: theme.color.brandSecondary.light,
    textTransform: "lowercase",
    letterSpacing: 1,
  },
}));
